module.exports = __webpack_public_path__ + "528e7332806622e1ba33735a10a79843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-11.jpg
// module id = 1151
// module chunks = 0